import { IoClose } from 'react-icons/io5';

import CUSTOM_STYLES from '../../utils/modalStyle';
import CategoriesAside from '../CategoriesAside/CategoriesAside';
import GenericModal from '../GenericModal/GenericModal';

import styles from './CategoriesModal.module.scss';

export default function CategoriesModal({ isOpen, setIsOpen, slug, category }) {
  const modal = {
    isOpen,
    closeModal: setIsOpen,
    headerClass: styles.modalHeader,
    customStyles: {
      overlay: {
        ...CUSTOM_STYLES.overlay,
      },
      content: {
        width: '41.45rem',
      },
    },
    icon: <IoClose className={styles.closeModal} />,
    bodyOverwrite: 'fullBody',
    isFullscreen: true,
    animate: true,
    navigation: [<h3 key={1}>Κατηγορίες</h3>],
    view: 'Categories',
    body: {
      Categories: <CategoriesAside slug={slug} isSticky category={category} />,
    },
  };

  return <GenericModal modal={modal} />;
}
